<template>
    <div class="popupover3 gtyTip" id="gtyTip" :class="{ active: isShow}">
        <div class="popupover3-bg" @click="onGoBack()"></div>
        <div class="gtyTip-m">
            <div class="gtyTip-close js-popupClose2" @click="onGoBack()"><img src="https://resource.rcclchina.com.cn/cruiseDetail/closed.png" /></div>
            <p class="gtyTip-title">温馨提醒：如预订随机舱房，请注意：</p>
            <p>1. 请您完成全款支付后，于出行前在个人中心订单查询页面确认舱房号。</p>
            <p>2. 随机舱房房间号为系统随机分配，可能无法满足楼层以及房间位置的指定需求。</p>
            <p>3. 部分随机阳台房/银卡套房为遮挡房型，阳台外侧悬挂救生艇，或阳台有部分面积被船体设施占用，阳台视线会有遮挡。</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "GtyPopup",
    props: {
        isShow: {
            type: Boolean
        },
        onGoBack: {
            type: Function
        }
    }
}
</script>

<style lang="less" scoped>
.popupover3 {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10200;
    display: none;
    width: 100%;
    height: 100%;
    .popupover3-bg {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
    }
    .gtyTip-m {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate3d(-50%, -50%, 0);
        -moz-transform: translate3d(-50%, -50%, 0);
        transform: translate3d(-50%, -50%, 0);
        width: 93%;
        padding: 20px;
        background: #fff;
        .gtyTip-close {
            position: absolute;
            top: 0;
            right: 0;
            width: 33px;
            height: 33px;
            padding: 5px;
            img {
                width: 100%;
            }
        }

        p {
            margin-top: 6px;
            margin-bottom: 0;
            color: #000;
            font-size: 13px;
        }

        .gtyTip-title {
            font-weight: bold;
        }
    }
}

.popupover3.active {
    display: block;
}
</style>